import httpClient, { ApiResponseType, FORM_DATA_CONFIG } from 'packages/http_client';
import {
  ResponseServiceRequestCommentType, ServiceRequestDocumentType,
} from 'packages/service_request_repository/types';
import { InvoiceType } from 'packages/invoice_repository/types';
import { SERVICE_REQUEST_COMMENT, SERVICE_REQUEST_DOCUMENT_API } from 'packages/service_request_repository/utils/constants';
import { unwrap } from '../api';
import { PortalScope } from './types';
import {
  getPortalRequest, getPortalPortfolio, readPages, context,
} from './api';

type LinkedRecord = { id: number, serviceRequestID: number };
const readRelated = async <T extends LinkedRecord>(url: string, startupId: number, requestId: number) => {
  await getPortalRequest(startupId, requestId);
  const rows = await readPages<T>(url, { service_request_id: requestId, $preload: 1 }, startupId);
  if (rows.some((row) => row.serviceRequestID !== requestId)) throw new Error('Unable to verify the request records');
  return rows;
};

export const getPortalComments = (startupId: number, requestId: number) => (
  readRelated<ResponseServiceRequestCommentType>(SERVICE_REQUEST_COMMENT, startupId, requestId)
);
export const getPortalDocuments = (startupId: number, requestId: number) => (
  readRelated<ServiceRequestDocumentType & LinkedRecord>(SERVICE_REQUEST_DOCUMENT_API, startupId, requestId)
);
export const getPortalInvoices = async (startupId: number, requestId: number) => {
  try {
    return await readRelated<InvoiceType>('/api/d/invoice', startupId, requestId);
  } catch (error) {
    throw new Error(`Unable to load invoices: ${error instanceof Error ? error.message : 'please retry'}`);
  }
};

export const addPortalComment = async (scope: PortalScope, startupId: number, requestId: number, text: string) => {
  const portfolio = await getPortalPortfolio(scope);
  if (!portfolio.some(({ id }) => id === startupId)) throw new Error('This startup is not in your portfolio');
  const request = await getPortalRequest(startupId, requestId);
  if ([1, 6, 7, 8].includes(request.status)) throw new Error('Comments are unavailable for this request');
  if (!text.trim()) throw new Error('Enter a comment');
  unwrap(await httpClient.post<ApiResponseType<{ status: string }>>(SERVICE_REQUEST_COMMENT, {
    _service_request_id: requestId, _message: text.trim(), _organization: 'Venture Builder',
  }, { ...FORM_DATA_CONFIG, ...context(startupId) }));
};
